<template>
  <div>
    <table-manager
      @filterChanged="filterChanged"
      @paginationChanged="paginationChanged"
      @ClickOnAddButton="showAdd"
      :options="options"
      />

    <basic-table
      :key="rerenderTable"
      v-if="buildingsList"
      :items="buildingsList"
      :fields="buildingsFields"
      :filter="filter"
      :filterFunction="function(row,filter){return true}"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :perPage="perPage"
      :totalRows="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :key="rerenderBottom"
      :totalRows="totalRows"
      :perPage="perPage"
      @input="onClickPageChange"
      v-model="currentPage"/>
    <editModal
    :editItem="currentRowBuildings"
    @updateBuildingsList="load"/>
  </div>
</template>

<script>
import editModal from './editModal'
export default {
  components: {
    editModal
  },
  data () {
    return {
      currentRowBuildings: null,
      options: {
        isShowAddButton: true,
        placeholder: this.$i18n.t('ID, Postal, Country...')
      },
      filter: '',
      perPage: 20,
      rerenderTable: 0,
      totalRows: 0,
      currentPage: 1,
      rerenderBottom: 0,

      buildingsFields: [
        {key: 'house_id', label: 'ID', sortable: true},
        {key: 'zones', label: this.$i18n.t('IP zone ID'), sortable: true},
        {key: 'connect_date', label: this.$i18n.t('Connected on'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'post_code', label: this.$i18n.t('ZIP code'), sortable: true},
        {key: 'country', label: this.$i18n.t('Country'), sortable: true},
        {key: 'region', label: this.$i18n.t('Province/State'), sortable: true},
        {key: 'city', label: this.$i18n.t('City'), sortable: true},
        {key: 'street', label: this.$i18n.t('Street'), sortable: true},
        {key: 'number', label: this.$i18n.t('Building#'), sortable: true},
        {key: 'building', label: this.$i18n.t('Constr.#'), sortable: true},
        {key: 'description', label: this.$i18n.t('Description'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ]
    }
  },
  methods: {
    showAdd () {
      this.currentRowBuildings = {
        house_id: 0,
        connect_date: this.$root.setDataWithSelectedTZ().format('YYYY-MM-DDTHH:mm'),
        post_code: '',
        country: '',
        region: '',
        city: '',
        street: '',
        number: '',
        building: '',
        zones_detailed: []
      }
      this.$root.$emit('bv::show::modal', 'modalEditBuildings', '#btnShow')
    },
    editItem (item) {
      this.currentRowBuildings = JSON.parse(JSON.stringify(item))
      this.currentRowBuildings.connect_date = this.$root.getMomentWithTZDelta(Number(this.currentRowBuildings.connect_date)).unix()
      this.$root.$emit('bv::show::modal', 'modalEditBuildings', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Buildings"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('ReferenceBooks/DELETE_BUILDINGS', item.house_id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.load()
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
      this.currentPage = 1
      this.$store.dispatch('ReferenceBooks/GET_BUILDINGS_PARAMS', {filter: this.filter, per_page: this.perPage, page: this.currentPage})
    },
    paginationChanged (value) {
      this.perPage = value
      this.currentPage = 1
      this.load()
    },
    onClickPageChange (val) {
      this.currentPage = val
      this.load()
    },
    async load () {
      await this.$store.dispatch('ReferenceBooks/GET_BUILDINGS_PARAMS', {filter: this.filter, per_page: this.perPage, page: this.currentPage})
      this.rerenderTable += 1
    }
  },
  computed: {
    buildingsList () {
      return this.$store.getters['ReferenceBooks/BUILDINGS_PAGED'].houses
    }

  },
  watch: {
    buildingsList: function (val) {
      this.totalRows = this.$store.getters['ReferenceBooks/BUILDINGS_PAGED'].total_rows
      this.rerenderTable += 1
    }
  },

  mounted () {
    this.load()
    this.$store.dispatch('ReferenceBooks/GET_IP_ZONES')
    this.$store.dispatch('ReferenceBooks/GET_STREETS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/referenceBook/buildings/main.vue